"use strict";
exports.__esModule = true;
exports.RHS_STATES = void 0;
exports.RHS_STATES = {
    INITIAL: 'initial',
    STEP_SELECTED: 'step_selected',
    TEST_STARTING: 'test_starting',
    TEST_STARTED: 'test_started',
};
